import React from "react"
import { Topics, Header, Footer /*, CookieBanner */ } from "@bw/layouts"
import { Seo } from "@bw/bits"
import { allNavsResolver } from "../../../utils/navigationsResolver"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"

const Layout = ({ children, pageContext }) => {
  const data = useStaticQuery(graphql`
    query MenuQuery {
      shortcuts: allNavNavigationSecondaire(
        sort: { fields: order, order: ASC }
      ) {
        nodes {
          page {
            locale
            to: url
            label: title
          }
        }
      }
      burger: allNavNavigationPrincipale(sort: { fields: order, order: ASC }) {
        nodes {
          page {
            locale
            to: url
            label: title
          }
        }
      }
    }
  `)

  const { burger, shortcuts } = React.useMemo(
    () => allNavsResolver(data, pageContext.locale),
    []
  )

  return (
    <>
      <Seo lang={pageContext.locale} />
      <Topics />
      <SiteWrapper>
        <Header {...{ shortcuts, burger }} />
        <main>{children}</main>
      </SiteWrapper>
      <Footer />
      {/*<CookieBanner />*/}
    </>
  )
}

const SiteWrapper = styled.div`
  @media (min-width: 500px) {
    min-height: 700px;
  }
  @media (min-width: 500px) and (max-width: 1199px) {
    padding-left: 65px;

    .header {
      padding-left: 65px;
    }
  }
`

export { Layout }
